import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Rotas permitidas para vendedores SEM assinatura ativa.
// Fluxo obrigatório: novo vendedor → tela de planos até escolher um plano.
const SELLER_ONBOARDING_ALLOWED = [
  '/seller/planos',
  '/seller/assinatura/sucesso',
  '/seller/assinatura/erro',
  '/seller/assinatura/pendente',
  '/seller/complete-profile',
  '/checkout',
];

const isSellerOnboardingRoute = (pathname) =>
  SELLER_ONBOARDING_ALLOWED.some((p) => pathname === p || pathname.startsWith(p + '/'));

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : null
  );

  useEffect(() => {
    if (location.state?.user) {
      setIsAuthenticated(true);
      return;
    }

    if (!loading) {
      setIsAuthenticated(user !== null);
    }
  }, [user, loading, location.state]);

  if (isAuthenticated === null || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-purple-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/" replace />;
  }

  // Gate para vendedores sem assinatura ativa
  const activeUser = user || location.state?.user;
  if (
    activeUser?.role === 'seller' &&
    activeUser?.has_active_subscription === false &&
    !isSellerOnboardingRoute(location.pathname)
  ) {
    return <Navigate to="/seller/planos" replace />;
  }

  return children;
};